







































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { EState, IDropDown } from '../Layout/SharedFolderLayout.vue'

@Component
export default class PcButtonArea extends Vue {
  @Prop() roleEditFile!: boolean
  @Prop() actionAreaState!: EState
  @Prop() isSelectAnyItem!: boolean
  @Prop() private checkAll!: boolean
  @Prop() private sortSelected!: any
  @Prop() private sortOptions!: IDropDown[]
  @Prop() filesLength!: number

  checkAllClone: boolean = this.checkAll
  isCommonTopic = !this.$route.params.groupId
  eState = EState

  @Watch('checkAll')
  watchCheckAll() {
    this.checkAllClone = this.checkAll
  }

  handleMoveToUnclassified(isFromBin: boolean) {
    this.$emit('handleMoveToUnclassified', isFromBin)
  }

  openConfirmDeleteBin(isFromBin: boolean) {
    this.$emit('openConfirmDeleteBin', isFromBin)
  }

  handleSortChange(index: number) {
    this.$emit('handleSortChange', index)
  }

  handleCheckAll() {
    this.$emit('handleCheckAll', this.checkAllClone)
  }

  openEditFolderModal() {
    this.$emit('openEditFolderModal')
  }

  handleDownloadFiles() {
    this.$emit('handleDownloadFiles')
  }

  pinMultipleFiles() {
    this.$emit('pinMultipleFiles')
  }
}
